import { ISelectionChangeArgs, ISelectItem } from "@components/inputs/select/Select.types";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { IconSize, TextAlign } from "../../enums";
import { AuditTrailIcon } from "../icon";
import IconSelect from "../inputs/select/IconSelect";
import { Header, Info, StyledVersionSelect, Title, VersionIcon } from "./AuditTrail.styles";

interface IProps extends WithTranslation {
    items: ISelectItem[];
    value: string;
    text: string;
    onChange?: (args: ISelectionChangeArgs) => void;

    className?: string;
}

const Icon = <AuditTrailIcon width={IconSize.M}/>;

class VersionSelect extends React.Component<IProps> {
    render() {
        return (
            <StyledVersionSelect className={this.props.className}>
                <Header>
                    <Title>{this.props.t("Components:VersionSelect.Change")}:</Title>
                    <Info>{this.props.text}</Info>
                </Header>
                <VersionIcon>
                    <IconSelect
                        hotspotId={"auditTrailVersionSelect"}
                        columns={[
                            {
                                textAlign: TextAlign.Right,
                                label: this.props.t("Components:VersionSelect.Date")
                            },
                            {
                                textAlign: TextAlign.Right,
                                label: this.props.t("Components:VersionSelect.Time")
                            },
                            {
                                label: this.props.t("Components:VersionSelect.Name")
                            },
                            {
                                label: this.props.t("Components:VersionSelect.Type")
                            }
                        ]}
                        icon={Icon}
                        items={this.props.items}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        useAutoSelection={false}
                    />
                </VersionIcon>
            </StyledVersionSelect>
        );
    }
}

const versionSelectWithTranslation = withTranslation("Components")(VersionSelect);
export { versionSelectWithTranslation as VersionSelect };